import { ChevronLeft } from 'lucide-react';

import { cn } from '../../../lib/cn';
import type { CompanyColor, CompanyRow } from './companies.schema';
import { COMPANY_COLORS } from './companies.schema';
import styles from './companies.module.css';

function companyColor(color: string | null): CompanyColor {
  return COMPANY_COLORS.includes(color as CompanyColor) ? (color as CompanyColor) : 'yellow';
}

function fallbackInitials(name: string): string {
  return name
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0] ?? '')
    .join('')
    .toUpperCase();
}

interface CompanyListProps {
  companies: CompanyRow[];
  onSelect: (company: CompanyRow) => void;
}

export function CompanyList({ companies, onSelect }: CompanyListProps) {
  return (
    <div className={styles.table} role="table" aria-label="חברות">
      <div className={cn(styles.rowGrid, styles.head)} role="row">
        <div role="columnheader" />
        <div role="columnheader">חברה</div>
        <div role="columnheader">תעשייה</div>
        <div role="columnheader">גודל</div>
        <div role="columnheader">אתר</div>
        <div role="columnheader" />
      </div>

      {companies.map((company) => {
        const color = companyColor(company.color);
        const initials = company.initials?.trim() ? company.initials : fallbackInitials(company.name);

        return (
          <button
            key={company.id}
            type="button"
            className={styles.rowGrid}
            role="row"
            onClick={() => {
              onSelect(company);
            }}
          >
            <span className={cn(styles.avatar, styles[color])} aria-hidden="true">
              {initials}
            </span>
            <span className={styles.companyCell}>
              <strong>{company.name}</strong>
              {company.address ? <small>{company.address}</small> : null}
            </span>
            <span>{company.industry ?? '—'}</span>
            <span>{company.size ?? '—'}</span>
            <span className={styles.urlCell} dir="ltr">
              {company.website ? <bdi>{company.website}</bdi> : '—'}
            </span>
            <ChevronLeft size={16} className={styles.chevron} aria-hidden="true" />
          </button>
        );
      })}
    </div>
  );
}
